<script>
import { mapState } from "vuex";

import Vue from "vue";

export default Vue.extend({
    name: "App",
    data() {
        return {
            logMessage: undefined,
            logColor: undefined,
        };
    },
    computed: {
        ...mapState({
            log: (state) => state.ui.log,
        }),
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                document.title = `DSGateway - ${to.name}`;
            },
        },
        log(value) {
            this.logMessage = value[value.length - 1];
            switch (this.logMessage.logLevel) {
                case 0:
                    this.logColor = "error";
                    break;
                case 1:
                    this.logColor = "warning";
                    break;
                case 3:
                    this.logColor = "info";
                    break;
                default:
                    this.logColor = "success";
                    break;
            }
        },
    },
    mounted() {
        if (this.$route.path != "/login") {
            this.axios.get("/auth").then((response) => {
                if (response?.status === 200) {
                    this.$store.dispatch("auth/fetchAccount");
                    this.$store.dispatch("gateway/fetchGateways");
                    this.$store.dispatch("schedule/fetchSchedules");
                }
            });
        }
    },
});
</script>

<template>
    <v-app id="app">
        <v-main>
            <router-view />
        </v-main>

        <!-- LogSnackbar -->
        <v-snackbar v-if="logMessage" v-model="logMessage" class="snackbar" timeout="5000" :color="logColor">{{ logMessage.message }}</v-snackbar>
    </v-app>
</template>

<style lang="scss">
#app {
    font-family: "CircularStd", "Roboto", Helvetica, Arial, sans-serif;
    background: $background;
}

@media only screen and (max-width: 850px) {
    .snackbar {
        bottom: calc($sidebar-width + 0.5rem) !important;
    }
}
</style>
